import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Loader } from "@egovernments/digit-ui-react-components";
import MapSubmissionSummary from "./MapSubmissionSummary";

function SearchSummary({ id, ref, handleDeclarationChange, declarationChecked, showDeclaration }) {
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("employee");
  const formType = "MAP_SUB";
  const { data = {}, isLoading, refetch } = Digit.Hooks.obps.useBPADetailsPage(
    stateId,
    { applicationNo: id, isEmployee },
    { formType, config: { staleTime: 0, cacheTime: 0, refetchOnMount: true, refetchOnWindowFocus: false, refetchOnReconnect: true } }
  );

  useEffect(() => {
    if (id && formType) {
      refetch();
    }
  }, [id, formType, refetch]);
  if (isLoading) {
    return <Loader />;
  }
  return (
    <React.Fragment>
      {!isLoading && data && (
        <MapSubmissionSummary
          formData={data?.BPA?.[0]}
          ref={ref}
          handleDeclarationChange={handleDeclarationChange}
          declarationChecked={declarationChecked}
          showDeclaration={showDeclaration}
        />
      )}
    </React.Fragment>
  );
}

export default SearchSummary;
